import { render, staticRenderFns } from "./Pos_promotion_create_new.vue?vue&type=template&id=7b43ad6b&scoped=true&"
import script from "./Pos_promotion_create_new.vue?vue&type=script&lang=js&"
export * from "./Pos_promotion_create_new.vue?vue&type=script&lang=js&"
import style0 from "./Pos_promotion_create_new.vue?vue&type=style&index=0&id=7b43ad6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b43ad6b",
  null
  
)

export default component.exports